import { render, staticRenderFns } from "./familiar-el.vue?vue&type=template&id=a9c7eaae"
import script from "./familiar-el.vue?vue&type=script&lang=js"
export * from "./familiar-el.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports